import { USER_RECEIVED } from '../actions/GetUser';
import { ACCOUNT_ACTIVATED } from '../actions/product-management/ActivateAccount';

const initialState = {
  id: null,
  name: null,
  first_name: null,
  last_name: null,
  display_name: null,
  product_management_active: false,
  has_accounts_data: false,
  loading: true,
  is_vendor_pending: false,
  current_team_has_leads: false,
  vendor_name: null,
  phone_number: null,
  email: null,
};

const user = (state = initialState, action) => {
  switch(action.type) {
    case USER_RECEIVED:
      return {
        ...action.user,
        loading: false,
      };
    case ACCOUNT_ACTIVATED:
      return {
        ...state,
        product_management_active: true,
      };
  }

  return state;
};

export default user;
